import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptors,
  withXsrfConfiguration,
} from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { MzicHttpInterceptorInterceptor } from '@mzic/http-interceptor';
import { collectionFlowInterceptors } from '@mzic/mzic-collection-flow';
import { appRoutes } from './app.routes';
import { TranslocoRootModule } from './transloco-root.module';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(appRoutes),
    provideAnimations(),
    importProvidersFrom(TranslocoRootModule),
    provideHttpClient(
      withXsrfConfiguration({
        cookieName: 'XSRF-TOKEN',
        headerName: 'X-XSRF-TOKEN',
      }),
      withInterceptors([...collectionFlowInterceptors]),
    ),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MzicHttpInterceptorInterceptor,
      multi: true,
    },
  ],
};
